"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeKeyframes = void 0;

var components_utils_1 = require("@conte-ltd/components-utils");

function mergeKeyframes() {
  var merges = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    merges[_i] = arguments[_i];
  }

  var _a = __read(merges),
      first = _a[0],
      second = _a[1],
      tail = _a.slice(2);

  if ((0, components_utils_1.isNil)(first)) {
    return [];
  }

  first = Array.isArray(first) ? first : [first];

  if ((0, components_utils_1.isNil)(second)) {
    return first;
  }

  second = Array.isArray(second) ? second : [second];
  var cnt1 = 0;
  var cnt2 = 0;
  var result = [];

  while (cnt1 < first.length || cnt2 < second.length) {
    if (cnt1 >= first.length) {
      result.push.apply(result, __spreadArray([], __read(second.slice(cnt2)), false));
      break;
    }

    if (cnt2 >= second.length) {
      result.push.apply(result, __spreadArray([], __read(first.slice(cnt1)), false));
      break;
    }

    var c1 = first[cnt1];
    var c2 = second[cnt2];

    if ((0, components_utils_1.isNil)(c1.offset)) {
      c1.offset = cnt1 * (first.length === 1 ? 0 : Math.round(1 / (first.length - 1)));
    }

    if ((0, components_utils_1.isNil)(c2.offset)) {
      c2.offset = cnt2 * (second.length === 1 ? 0 : Math.round(1 / (second.length - 1)));
    }

    if (c1.offset === c2.offset) {
      var mergedTransform = 'transform' in c1 && 'transform' in c2 ? {
        transform: c1.transform + " " + c2.transform
      } : {};
      result.push(__assign(__assign(__assign({}, c1), c2), mergedTransform));
      cnt1++;
      cnt2++;
    } else if (c1.offset > c2.offset) {
      result.push(c2);
      cnt2++;
    } else {
      result.push(c1);
      cnt1++;
    }
  }

  return tail.length > 0 ? mergeKeyframes.apply(void 0, __spreadArray([result], __read(tail), false)) : result;
}

exports.mergeKeyframes = mergeKeyframes;